exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-linear[data-v-6fd7f93c]{position:absolute;margin:0;bottom:0}.fondo[data-v-6fd7f93c]{background:-webkit-gradient(linear,left bottom,left top,from(#828f98),to(#1d1a15));background:linear-gradient(0deg,#828f98,#1d1a15)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fd7f93c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/layouts/sinmenu.vue
// module id = Ri7+
// module chunks = 0